import { render } from "./ServizioListinoDataTable.vue?vue&type=template&id=247a4080"
import script from "./ServizioListinoDataTable.vue?vue&type=script&lang=js"
export * from "./ServizioListinoDataTable.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__